import i18n from '../../i18n';
import { isSaudiBrand } from '../../products/saudi/utils/isSaudiBrand';

/** Saudi administrative regions for territory / geographic segmentation. */
export const SAUDI_REGIONS = [
  { value: 'riyadh', label: 'الرياض' },
  { value: 'makkah', label: 'مكة المكرمة' },
  { value: 'madinah', label: 'المدينة المنورة' },
  { value: 'eastern', label: 'المنطقة الشرقية (الدمام)' },
  { value: 'qassim', label: 'القصيم' },
  { value: 'asir', label: 'عسير' },
  { value: 'tabuk', label: 'تبوك' },
  { value: 'hail', label: 'حائل' },
  { value: 'northern', label: 'الحدود الشمالية' },
  { value: 'jazan', label: 'جازان' },
  { value: 'najran', label: 'نجران' },
  { value: 'bahah', label: 'الباحة' },
  { value: 'jouf', label: 'الجوف' },
];

/** GCC countries for cross-border segmentation. */
export const GCC_COUNTRIES = [
  { value: 'sa', label: 'المملكة العربية السعودية' },
  { value: 'ae', label: 'الإمارات العربية المتحدة' },
  { value: 'kw', label: 'الكويت' },
  { value: 'qa', label: 'قطر' },
  { value: 'bh', label: 'البحرين' },
  { value: 'om', label: 'عُمان' },
];

/** Marketing channels popular in KSA (WhatsApp-first). */
export const SAUDI_MARKETING_CHANNELS = [
  { value: 'whatsapp', label: 'واتساب للأعمال' },
  { value: 'sms', label: 'رسائل SMS' },
  { value: 'email', label: 'البريد الإلكتروني' },
  { value: 'twitter', label: 'تويتر / X' },
  { value: 'instagram', label: 'إنستغرام' },
  { value: 'snapchat', label: 'سناب شات' },
  { value: 'tiktok', label: 'تيك توك' },
  { value: 'google_ads', label: 'إعلانات Google' },
  { value: 'events', label: 'معارض ومؤتمرات' },
  { value: 'referral', label: 'إحالة / توصية' },
];

/** Legacy region aliases mapped to major Saudi cities (migration from old demo keys). */
export const LEGACY_REGION_ALIASES = [
  { value: 'riyadh', label: 'الرياض' },
  { value: 'jeddah', label: 'جدة' },
  { value: 'dammam', label: 'الدمام' },
  { value: 'mecca', label: 'مكة المكرمة' },
  { value: 'medina', label: 'المدينة المنورة' },
];

function getLegacyMarketingChannelOptions() {
  return [
    { value: 'email', label: i18n.t('common.email') },
    { value: 'sms', label: i18n.t('modules.crm.pages.leadsPage.source_sms') },
    { value: 'social', label: i18n.t('modules.crm.pages.leadsPage.source_social') },
    { value: 'events', label: i18n.t('modules.crm.pages.leadsPage.source_exhibition') },
  ];
}

export function getBrandRegionOptions() {
  return SAUDI_REGIONS;
}

export function getBrandMarketingChannelOptions() {
  return isSaudiBrand() ? SAUDI_MARKETING_CHANNELS : getLegacyMarketingChannelOptions();
}

export function getBrandGccCountryOptions() {
  return GCC_COUNTRIES;
}

export function getRegionLabel(value) {
  const all = [...SAUDI_REGIONS, ...LEGACY_REGION_ALIASES, ...GCC_COUNTRIES];
  return all.find((r) => r.value === value)?.label || value || '—';
}

export function getMarketingChannelLabel(value) {
  const all = [...SAUDI_MARKETING_CHANNELS, ...getLegacyMarketingChannelOptions()];
  return all.find((c) => c.value === value)?.label || value || '—';
}
